module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-container', {
    staticClass: "mt-3 resources-view",
    staticStyle: {
      "padding-top": "60px",
      "max-width": "1442px",
      "position": "relative"
    }
  }, [(_vm.pageData && _vm.pageData.resources) ? _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticClass: "mt-2",
    attrs: {
      "xs12": ""
    }
  }, [_c('p', {
    staticClass: "page-header",
    staticStyle: {
      "color": "#4a4a4a",
      "font-size": "29px",
      "font-weight": "bolder",
      "text-justify": "auto"
    }
  }, [_vm._v("\n          " + _vm._s(_vm.pageData.resources.header))])]), _vm._v(" "), _c('v-flex', {
    staticClass: "page-subtitle",
    staticStyle: {
      "color": "#4a4a4a",
      "font-size": "18px",
      "font-weight": "400",
      "margin": "0px"
    },
    attrs: {
      "xs12": ""
    }
  }, [_c('div', {
    staticStyle: {
      "margin-top": "-10px",
      "padding-top": "0px"
    }
  }, [_c('p', {
    staticStyle: {
      "text-justify": "auto",
      "line-height": "22px"
    }
  }, [_vm._v("\n            " + _vm._s(_vm.pageData.resources.sub_text) + "\n          ")])])])], 1) : _vm._e(), _vm._v(" "), _c('v-layout', [_c('v-flex', {
    staticClass: "search_field",
    attrs: {
      "xs9": "",
      "md4": ""
    }
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("\n          search\n        ")]), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "name": "input-3",
      "placeholder": "Type to search"
    },
    model: {
      value: (_vm.search),
      callback: function($$v) {
        _vm.search = $$v
      },
      expression: "search"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs3": "",
      "hidden-md-and-up": ""
    }
  }, [_c('v-btn', {
    staticClass: "right",
    staticStyle: {
      "margin-top": "14px",
      "text-transform": "capitalize"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.viewMobileFilter = !_vm.viewMobileFilter
      }
    }
  }, [_vm._v("\n          Filter\n        ")])], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": _vm.breakpoint === 'xs' || _vm.breakpoint === 'sm',
      "id": "resources-main-container"
    }
  }, [_c('v-flex', {
    staticClass: "filter-sidebar-container hidden-sm-and-down",
    attrs: {
      "xs12": "",
      "md3": ""
    }
  }, [_c('v-card', {
    staticClass: "filter_sidebar",
    style: ({
      width: _vm.width
    }),
    attrs: {
      "color": "white px-3 py-4"
    }
  }, [_c('h3', {
    staticClass: "secondary--text"
  }, [_vm._v("Content Type")]), _vm._v(" "), _c('h4', {
    staticClass: "secondary--text",
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.featuredResources(9)
      }
    }
  }, [_vm._v("All content")]), _vm._v(" "), _c('ul', _vm._l((_vm.contentType), function(t, index) {
    return _c('li', {
      key: index
    }, [_c('a', {
      attrs: {
        "href": "#"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.filterPost('contenttype', t)
        }
      }
    }, [_vm._v(_vm._s(t))])])
  }), 0), _vm._v(" "), _c('h3', {
    staticClass: "secondary--text"
  }, [_vm._v("Category")]), _vm._v(" "), _c('h4', {
    staticClass: "secondary--text",
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.featuredResources(9)
      }
    }
  }, [_vm._v("All categories")]), _vm._v(" "), _c('ul', _vm._l((_vm.category), function(c, index) {
    return _c('li', {
      key: index
    }, [_c('a', {
      attrs: {
        "href": "#"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.filterPost('category', c)
        }
      }
    }, [_vm._v(_vm._s(c))])])
  }), 0), _vm._v(" "), _c('h3', {
    staticClass: "secondary--text"
  }, [_vm._v("Date Posted")]), _vm._v(" "), _c('div', {
    staticClass: "date_range"
  }, [_c('v-menu', {
    attrs: {
      "lazy": "",
      "close-on-content-click": false,
      "transition": "scale-transition",
      "offset-y": "",
      "full-width": "",
      "nudge-left": 40,
      "max-width": "290px"
    },
    model: {
      value: (_vm.datepickermenufrom),
      callback: function($$v) {
        _vm.datepickermenufrom = $$v
      },
      expression: "datepickermenufrom"
    }
  }, [_c('v-text-field', {
    attrs: {
      "slot": "activator",
      "required": "",
      "label": "From",
      "readonly": ""
    },
    slot: "activator",
    model: {
      value: (_vm.fromdate),
      callback: function($$v) {
        _vm.fromdate = $$v
      },
      expression: "fromdate"
    }
  }), _vm._v(" "), _c('v-date-picker', {
    attrs: {
      "no-title": "",
      "scrollable": ""
    },
    model: {
      value: (_vm.fromdate),
      callback: function($$v) {
        _vm.fromdate = $$v
      },
      expression: "fromdate"
    }
  }, [
    [_c('v-card-actions', [_c('v-btn', {
      attrs: {
        "flat": "",
        "primary": ""
      },
      on: {
        "click": function($event) {
          _vm.datepickermenufrom = false
        }
      }
    }, [_vm._v("OK")])], 1)]
  ], 2)], 1), _vm._v(" "), _c('v-menu', {
    attrs: {
      "lazy": "",
      "close-on-content-click": false,
      "transition": "scale-transition",
      "offset-y": "",
      "full-width": "",
      "nudge-left": 40,
      "max-width": "290px"
    },
    model: {
      value: (_vm.datepickermenuto),
      callback: function($$v) {
        _vm.datepickermenuto = $$v
      },
      expression: "datepickermenuto"
    }
  }, [_c('v-text-field', {
    attrs: {
      "slot": "activator",
      "required": "",
      "label": "To",
      "readonly": ""
    },
    slot: "activator",
    model: {
      value: (_vm.todate),
      callback: function($$v) {
        _vm.todate = $$v
      },
      expression: "todate"
    }
  }), _vm._v(" "), _c('v-date-picker', {
    attrs: {
      "no-title": "",
      "scrollable": ""
    },
    model: {
      value: (_vm.todate),
      callback: function($$v) {
        _vm.todate = $$v
      },
      expression: "todate"
    }
  }, [
    [_c('v-card-actions', [_c('v-btn', {
      attrs: {
        "flat": "",
        "primary": ""
      },
      on: {
        "click": function($event) {
          _vm.datepickermenuto = false
        }
      }
    }, [_vm._v("OK")])], 1)]
  ], 2)], 1)], 1), _vm._v(" "), _c('v-btn', {
    staticClass: "date_btn",
    attrs: {
      "flat": "",
      "primary": ""
    },
    on: {
      "click": _vm.save
    }
  }, [_vm._v("Filter")])], 1)], 1), _vm._v(" "), (_vm.viewMobileFilter) ? _c('mobile-resource-filter', {
    staticClass: "hidden-md-and-up",
    attrs: {
      "hidden-md-and-up": "",
      "filterPost": _vm.filterPost,
      "featuredResources": _vm.featuredResources,
      "contentType": _vm.contentType,
      "category": _vm.category
    }
  }) : _vm._e(), _vm._v(" "), _c('v-flex', {
    staticClass: "px-2",
    attrs: {
      "xs12": _vm.breakpoint === 'xs',
      "sm12": _vm.breakpoint === 'sm',
      "md9": _vm.breakpoint === 'md' || _vm.breakpoint === 'lg' || _vm.breakpoint === 'xl'
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, _vm._l((_vm.sortedList), function(n, index) {
    return ((index + 1) <= _vm.counter) ? _c('v-flex', {
      key: n.id,
      attrs: {
        "xs12": _vm.breakpoint === 'xs',
        "xs6": _vm.breakpoint === 'sm',
        "xs4": _vm.breakpoint === 'md' || _vm.breakpoint === 'lg' || _vm.breakpoint === 'xl',
        "px-2": "",
        "py-2": ""
      },
      on: {
        "click": function($event) {
          return _vm.viewResource(n)
        }
      }
    }, [_c('v-card', {
      staticClass: "resource_card"
    }, [_c('div', {
      staticClass: "card_img"
    }, [(n.media.id) ? _c('iframe', {
      staticStyle: {
        "width": "100%",
        "height": "180px",
        "border": "none"
      },
      attrs: {
        "src": n.media.embedUrl,
        "allowfullscreen": ""
      }
    }) : _c('img', {
      staticStyle: {
        "width": "100%",
        "height": "180px"
      },
      attrs: {
        "src": n.media
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "resource_content"
    }, [_c('span', {
      staticClass: "resource-title secondary--text"
    }, [_vm._v("\n                  " + _vm._s(n.title) + "\n                ")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', {
      staticClass: "resource-date"
    }, [_vm._v("\n\n                  " + _vm._s(_vm._f("actualDate")(n.revisiondate)) + "\n                ")]), _vm._v(" "), _c('div', {
      staticClass: "description",
      domProps: {
        "innerHTML": _vm._s(_vm.excerptDescs(n.content))
      }
    })])])], 1) : _vm._e()
  }), 1), _vm._v(" "), _c('v-flex', {
    staticClass: "load-data-div",
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "xs12": "",
      "md12": ""
    }
  }, [(_vm.sortedList.length > _vm.counter) ? _c('button', {
    staticClass: "btn btn--raised btn--round theme--dark primary load-more",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.counterPost(_vm.countlength)
      }
    }
  }, [_vm._v("Load More")]) : _vm._e()])], 1)], 1)], 1), _vm._v(" "), _c('resources-modal', {
    staticStyle: {
      "width": "600px"
    },
    attrs: {
      "dialog": _vm.dialog,
      "item": _vm.item
    },
    on: {
      "cancel": function($event) {
        return _vm.cancel()
      }
    }
  }), _vm._v(" "), (_vm.user.uid) ? _c('side-view-chat') : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-79dc7bf6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/ResourcesView.vue
// module id = 1701
// module chunks = 18